// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zJgA","col":"styles_col__3mmV1"};